import "./disclosure_download.scss";
import { Icon } from "@/elements/icon/icon";
import { Link } from "@/elements/link/link";
import { Text } from "@/elements/text/text";
import { type ReactElement } from "react";

interface Props {
  href: string;
  title: string;
  subtitle?: string;
  padding?: number;
  ariaLabel?: string;
}

export function DisclosureDownload({
  href,
  title,
  subtitle,
  padding = 16,
  ariaLabel,
}: Props): ReactElement {
  return (
    <div
      className="disclosure-download"
      style={
        {
          "--padding": `${padding}px`,
        } as React.CSSProperties
      }
    >
      <div className="disclosure-download__icon">
        <Icon name="download" size={24} color="inverted-pairings-default" />
      </div>
      <div className="disclosure-download__link">
        <Link
          href={href}
          type="sh1-xbold"
          target="_blank"
          ariaLabel={ariaLabel}
        >
          {title}
        </Link>
      </div>
      {subtitle && (
        <div className="disclosure-download__subtitle">
          <Text htmlElement="p" type="caption" color="neutral-on-surface">
            {subtitle}
          </Text>
        </div>
      )}
    </div>
  );
}
